const CHANNEL_NAME = 'auth_session';

export const AUTH_SESSION_MSG = {
  AUTH_CHANGED: 'AUTH_CHANGED',
  LOGOUT: 'LOGOUT',
};

let channel = null;

function getChannel() {
  if (typeof BroadcastChannel === 'undefined') {
    return null;
  }
  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }
  return channel;
}

export function postAuthSessionMessage(message) {
  try {
    const ch = getChannel();
    if (ch) {
      ch.postMessage(message);
    }
  } catch (e) {
    console.error('BroadcastChannel error', e);
  }
}

export function subscribeAuthSession(handler) {
  const ch = getChannel();
  if (!ch) {
    return () => {};
  }

  const onMessage = (event) => handler(event.data);
  ch.addEventListener('message', onMessage);

  return () => {
    ch.removeEventListener('message', onMessage);
  };
}

export function broadcastAuthChanged() {
  postAuthSessionMessage({ type: AUTH_SESSION_MSG.AUTH_CHANGED });
}

export function broadcastLogout() {
  postAuthSessionMessage({ type: AUTH_SESSION_MSG.LOGOUT });
}
